import styled from "styled-components";
import "../../styles/variables.css";

export const TooltipText = styled.div`
  cursor: pointer;
`;

export const TooltipBox = styled.div`
  position: absolute;
  top: calc(100% + -14px);
  left: 30px;
  visibility: hidden;
  color: transparent;
  border-radius: 4px;
  z-index: 1;
  box-shadow: 0px 2px 16px 20px rgb(0 0 0 / 4%);
  border: 1px solid #0000000a;

  &:before {
    content: "";
    width: 0;
    height: 0;
    left: 92px;
    top: -10px;
    position: absolute;

    box-shadow: -17px 20px 20px 10px rgb(0 0 0 / 5%);
    border: 10px solid var(--white);
    transform: rotate(135deg);
    transition: border 0.3s ease-in-out;
  }
`;

export const TooltipCard = styled.div`
  position: relative;
  & ${TooltipText}:hover + ${TooltipBox} {
    visibility: visible;
    color: var(--white);
    background-color: var(--white);
    width: 300px;
    height: auto;
    box-sizing: border-box;
    padding: 16px;

    animation: fadeIn 0.3s;
    -webkit-animation: fadeIn 0.3s;
    -moz-animation: fadeIn 0.3s;
    -o-animation: fadeIn 0.3s;
    -ms-animation: fadeIn 0.3s;

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }

    @-moz-keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }

    @-webkit-keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }

    @-o-keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }

    @-ms-keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }
`;
